const SummaryBoxPaymentMethod = ({ method }) => {
  switch (method.paymentMethodInfo.method) {
    case 'CREDIT_CARD':
      return (
        <p className="summary-info ff-graphik fw-normal fs-p3 c-midnight">
          {method.cardBrand}
          {' '}
          •••• -
          {method.cardlast4Numbers}
        </p>
      );
    case 'AFFIRM':
      return <p className="summary-info ff-graphik fw-normal fs-p3 c-midnight">Affirm</p>;
    case 'AMAZON_PAY':
      return <p className="summary-info ff-graphik fw-normal fs-p3 c-midnight">Amazon Pay</p>;
    case 'APPLE_PAY':
      return <p className="summary-info ff-graphik fw-normal fs-p3 c-midnight">Apple Pay</p>;
    case 'PAYPAL':
      return <p className="summary-info ff-graphik fw-normal fs-p3 c-midnight">PayPal</p>;
    case 'SPLIT_IT':
      return <p className="summary-info ff-graphik fw-normal fs-p3 c-midnight">Splitit</p>;
    case 'CHARGE_AFTER':
      return <p className="summary-info ff-graphik fw-normal fs-p3 c-midnight">Purple Financing</p>;
    default:
      return method.paymentMethodInfo.method;
  }
};

export default SummaryBoxPaymentMethod;
